const serialize = (o) => JSON.stringify(o, null, 2);
const assertUnreachable = (ignored, message) => {
  throw new Error(`${message}: ${serialize(ignored)}`);
};
export default assertUnreachable;
